/**
 * CTR Collection Products
 * – AJAX tag-pill filtering (no page reload)
 * – Variant pill selection with dynamic price updates
 *
 * Uses event delegation so everything keeps working after AJAX DOM swaps.
 */
(function () {
  function isTargetSectionEvent(event) {
    var section = event && event.target ? event.target : null;
    return section && section.classList && section.classList.contains('shopify-section') && section.querySelector('.ctr-collection-products-v2');
  }

  /* ===================================================
     1.  TAG-PILL AJAX FILTERING
     =================================================== */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ctr-collection-products-v2__tab');
    if (!pill) return;
    e.preventDefault();

    var section = pill.closest('.ctr-collection-products-v2');
    if (!section) return;

    /* Already active — nothing to do */
    if (pill.classList.contains('ctr-collection-products-v2__tab--active')) return;

    var sectionId = section.dataset.sectionId;
    var collectionUrl = section.dataset.collectionUrl;
    var tag = pill.dataset.tag; /* empty string = "All" */

    /* ── Build target URL ── */
    var newPath = tag ? collectionUrl + '/' + tag : collectionUrl;

    var currentParams = new URLSearchParams(window.location.search);
    var fetchUrl = new URL(newPath, window.location.origin);

    /* Keep existing sort_by */
    if (currentParams.has('sort_by')) {
      fetchUrl.searchParams.set('sort_by', currentParams.get('sort_by'));
    }

    /* section_id tells Shopify to return only this section's HTML */
    fetchUrl.searchParams.set('section_id', sectionId);

    /* ── Update active pill immediately ── */
    section.querySelectorAll('.ctr-collection-products-v2__tab').forEach(function (t) {
      t.classList.remove('ctr-collection-products-v2__tab--active');
    });
    pill.classList.add('ctr-collection-products-v2__tab--active');

    /* ── AJAX fetch ── */
    var container = document.getElementById('ProductGridContainer');
    if (container) {
      container.style.transition = 'opacity .2s ease';
      container.style.opacity = '0.3';
    }

    fetch(fetchUrl.toString())
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var newContainer = parsed.getElementById('ProductGridContainer');

        if (container && newContainer) {
          container.innerHTML = newContainer.innerHTML;
        }
        if (container) {
          container.style.opacity = '1';
        }

        /* Update the sort form action so future sorts use the tag-filtered URL */
        var sortForm = section.querySelector('form[is="facet-form"]');
        if (sortForm) {
          sortForm.setAttribute('action', newPath);
        }

        /* Fire custom event so other scripts can react */
        document.dispatchEvent(new CustomEvent('collection:rerendered'));
      })
      .catch(function () {
        if (container) container.style.opacity = '1';
      });

    /* ── Update browser URL (without section_id) ── */
    var historyUrl = new URL(newPath, window.location.origin);
    if (currentParams.has('sort_by')) {
      historyUrl.searchParams.set('sort_by', currentParams.get('sort_by'));
    }
    history.pushState({}, '', historyUrl.toString());
  });

  /* ===================================================
     2.  VARIANT-PILL SELECTION (price / badge updates)
     =================================================== */
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.ctr-collection-products-v2__variant-pill');
    if (!pill) return;

    var container = pill.closest('.ctr-collection-products-v2__variants');
    if (!container) return;

    /* Update active state */
    container.querySelectorAll('.ctr-collection-products-v2__variant-pill').forEach(function (p) {
      p.classList.remove('ctr-collection-products-v2__variant-pill--active');
    });
    pill.classList.add('ctr-collection-products-v2__variant-pill--active');

    /* Find the parent card */
    var card = pill.closest('.ctr-collection-products-v2__card');
    if (!card) return;

    var priceEl        = card.querySelector('[data-price]');
    var comparePriceEl = card.querySelector('[data-compare-price]');
    var atcBtn         = card.querySelector('[data-atc-btn]');
    var priceDisplay   = card.dataset.priceDisplay || 'price_compare';
    var fromPrefix     = card.dataset.fromPricePrefix || 'From';

    var price        = pill.dataset.variantPrice;
    var comparePrice = pill.dataset.variantComparePrice;
    var variantId    = pill.dataset.variantId;
    var sellingPlanId = pill.dataset.sellingPlanId;
    var variantAvailable = pill.dataset.variantAvailable;

    /* Update price */
    if (priceEl) {
      priceEl.textContent = priceDisplay === 'from' ? fromPrefix + ' ' + price : price;
    }

    /* Update compare price in price_compare mode */
    if (priceDisplay === 'price_compare') {
      if (comparePrice) {
        if (comparePriceEl) {
          comparePriceEl.innerHTML = '<s>' + comparePrice + '</s>';
          comparePriceEl.style.display = '';
        }
      } else if (comparePriceEl) {
        comparePriceEl.style.display = 'none';
      }
    }

    /* Update add-to-cart button variant */
    if (atcBtn && variantId) {
      atcBtn.dataset.variantId = variantId;
      if (sellingPlanId) {
        atcBtn.dataset.sellingPlanId = sellingPlanId;
      } else {
        delete atcBtn.dataset.sellingPlanId;
      }
      atcBtn.disabled = variantAvailable === 'false';
    }

    var productLink = card.querySelector('[data-product-link]');
    var variantUrl = pill.dataset.variantUrl;
    if (productLink && variantUrl) {
      productLink.href = variantUrl;
    }
  });

  /* ===================================================
     3.  ADD TO CART
     =================================================== */
  function handleAfterAdd(triggerButton) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.show(triggerButton);
    } else {
      window.location.href = '/cart';
    }
  }

  async function addCardToCart(button) {
    var variantId = button.dataset.variantId;
    if (!variantId) return;

    var priceType = button.dataset.priceType || 'subscription';
    var sellingPlanId = button.dataset.sellingPlanId;
    var item = {
      id: Number(variantId),
      quantity: 1
    };

    if (priceType === 'subscription' && sellingPlanId) {
      item.selling_plan = Number(sellingPlanId);
    }

    try {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('is-loading');

      var sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
      );

      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: sectionsToBundle,
          sections_url: window.location.pathname
        })
      });

      var parsedState = await response.json();

      if (!response.ok || parsedState.status) {
        alert(parsedState.description || parsedState.message || 'Error adding to cart.');
        return;
      }

      var cartResponse = await fetch('/cart.js', window.FoxTheme.utils.fetchConfig());
      var cartJson = await cartResponse.json();
      cartJson.sections = parsedState.sections;

      window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: { product: parsedState }
        })
      );

      handleAfterAdd(button);
    } catch (error) {
      console.error('Collection products v2 add to cart error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-loading');
    }
  }

  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-atc-btn]');
    if (!button) return;

    e.preventDefault();
    e.stopPropagation();

    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;

    addCardToCart(button);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (!isTargetSectionEvent(event)) return;
    document.dispatchEvent(new CustomEvent('collection:rerendered'));
  });

  document.addEventListener('shopify:section:select', function (event) {
    if (!isTargetSectionEvent(event)) return;
    document.dispatchEvent(new CustomEvent('collection:rerendered'));
  });
})();
